module.exports = __webpack_public_path__ + "assets/img/usa-news.a21190d7.svg";